import api from '../api/axios';

export const notasService = {
  getNotas: async () => {
    const { data } = await api.get('/notes');
    return data;
  },

  crearNota: async (datos) => {
    const { data } = await api.post('/notes', datos);
    return data;
  },

  eliminarNota: async (id) => {
    const { data } = await api.delete(`/notes/${id}`);
    return data;
  },
};
